export default "__VITE_ASSET__CYY_yIo4__"